<template>
    <div @mouseleave="hideHighLight" class="digital_newspaper_layout">
        <div class="img_center" v-if="imgSrc">
            <img :usemap="'#newspaperMap_'+randomId" alt="图片加载中" :src="imgSrc">
            <div class="area_list">
                <img :src="imgSrc">
                <map :name="'newspaperMap_'+randomId" :id="'newspaperMap_'+randomId" v-if="areaMapList">
                    <area v-if="containerWidthHeight" @click="clickArea(area,index)" shape="polygon" :coords="calcArea(area.layoutCoordinate)" v-for="(area,index) in areaMapList" @mouseenter="showHighLight(area.layoutCoordinate)" :title="area.documentTitle">
                </map>
                <div v-show="highLightArea" :style="highLightArea" class="high_light"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'digitalNewspaperLayout',
    props: {
        areaMapList: {
            type: Array,
            required: true
        },
        imgSrc: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            highLightArea: '',
            randomId: Math.round(Math.random() * 1000000),
            containerWidthHeight: ''
        }
    },
    mounted() {
        let $container = $(this.$el);
        this.containerWidthHeight = {
            width: $container.width(),
            height: $container.height()
        }
    },
    methods: {
        /**
         * [clickArea description] 点击热区
         * @param  {[type]} area [description] 热区数据
         * @return {[type]}      [description]
         */
        clickArea(area, index) {
            this.$emit('click', area);
            this.$emit('update:articleIndex', index);
        },
        /**
         * [showHighLight description] 显示高亮
         * @param  {[type]} area [description]
         * @return {[type]}      [description]
         */
        showHighLight(data) {
            let dataArray = [];
            let array = [];
            dataArray = data.split(",");
            for (let i = 0; i < dataArray.length; i += 2) {
                dataArray[i] = dataArray[i];
                dataArray[i + 1] = dataArray[i + 1];
                array.push([dataArray[i], dataArray[i + 1]]);
            }
            for (let i in array) {
                let elem = array[i];
                array[i] = elem[0] + ' ' + elem[1];
            }
            let clipPath = array.join(",");
            clipPath = `polygon(${clipPath})`
            this.highLightArea = {
                '-webkit-clip-path': clipPath,
                'clip-path': clipPath,
            };
        },
        /**
         * [hideHightLight description] 隐藏高亮
         * @return {[type]} [description]
         */
        hideHighLight() {
            this.highLightArea = "";
        }
    },
    computed: {
        calcArea() {
            let self = this;
            return data => {
                if (!data) {
                    return {};
                }
                let dataArray = [];
                let array = [];
                dataArray = data.split(",");
                if (dataArray[0].indexOf("%") > 0) { //如果坐标是百分比，要将其转换为数字
                    dataArray = dataArray.map((value, index) => {
                        value = Number(value.replace(/%/g, ""));
                        if (index % 2 == 0) {
                            return value * self.containerWidthHeight.width / 100;
                        } else {
                            return value * self.containerWidthHeight.height / 100;
                        }
                    });
                }
                for (let i = 0; i < dataArray.length; i += 2) {
                    dataArray[i] = dataArray[i];
                    dataArray[i + 1] = dataArray[i + 1];
                    array.push([dataArray[i], dataArray[i + 1]]);
                }
                for (let i in array) {
                    let elem = array[i];
                    array[i] = elem[0] + ',' + elem[1];
                }
                let clipPath = array.join(",");
                return clipPath
            }
        },
    }
}
</script>
<style scoped lang="less">
.digital_newspaper_layout {
    width: 100%;
    height: 655px;

    .img_center {
        width: 100%;
        height: 100%;
        position: relative;

        &>img {
            width: 100%;
            height: 100%;
            position: relative;
            z-index: 1;
            opacity: 0;
        }

        .area_list {
            display: inline-block;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;

            img {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
            }

            .high_light {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                background: #FFBE5C;
                opacity: 0.35;
            }

            map {
                area {
                    cursor: pointer;
                }
            }
        }
    }
}
</style>